import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import AvisosTabla from './AvisosTabla.jsx';

const AvisosListar = () => {
    return (
      <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Administración de avisos</Link></li>
        <li className="breadcrumb-item active">Listado de avisos</li>
      </ol>
      <h1 className="page-header">Administración de avisos <small></small></h1>
      <Panel>
        <PanelHeader>Avisos registrados</PanelHeader>
        <PanelBody>
            <AvisosTabla/>
        </PanelBody>
      </Panel>
    </div>
    );
  };
  export default AvisosListar;
